import { render, staticRenderFns } from "./embedList.vue?vue&type=template&id=5df11602&scoped=true&"
import script from "./embedList.vue?vue&type=script&lang=js&"
export * from "./embedList.vue?vue&type=script&lang=js&"
import style0 from "./embedList.vue?vue&type=style&index=0&id=5df11602&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df11602",
  null
  
)

export default component.exports